var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHome = function SvgHome(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "home_svg__a",
    width: 24,
    height: 24,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h24v24H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#home_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1C1B1F",
    d: "M11.4 2.93a1 1 0 0 1 1.28 0l10.4 8.63-.716.902-2.24-1.67v9.51a1 1 0 0 1-1 .995h-14.1c-.552 0-1-.445-1-.995v-9.51l-2.24 1.67-.716-.902zm-3.37 9.79q0 1.14 1.24 2.43c.826.861 1.75 1.76 2.78 2.68q1.575-1.39 2.82-2.68 1.24-1.29 1.24-2.43c0-.631-.218-1.16-.654-1.57a2.19 2.19 0 0 0-1.57-.628 2.26 2.26 0 0 0-1.03.233 3 3 0 0 0-.805.586 2.3 2.3 0 0 0-.779-.586 2.3 2.3 0 0 0-1.01-.233q-.92 0-1.58.625-.657.625-.656 1.57zm10.5 7.44c.221 0 .4-.178.4-.398v-9.85l-6.63-5.88a.4.4 0 0 0-.533 0l-6.63 5.88v9.85c0 .22.179.398.4.398z",
    style: {
      fill: "#1c1b1f"
    }
  })));
};
export default SvgHome;